/**
 * @generated SignedSource<<ea24f87a995c6755a53431f0b91381dd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CustomFieldDropdownOptionsModal_viewer$data = {
  readonly customFieldDefinition: {
    readonly options?: ReadonlyArray<{
      readonly id: string;
      readonly displayName: string;
      readonly isUsed: boolean;
    }>;
  } | null;
  readonly " $fragmentType": "CustomFieldDropdownOptionsModal_viewer";
};
export type CustomFieldDropdownOptionsModal_viewer$key = {
  readonly " $data"?: CustomFieldDropdownOptionsModal_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CustomFieldDropdownOptionsModal_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "customFieldId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CustomFieldDropdownOptionsModal_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "customFieldId"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "customFieldDefinition",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CustomFieldDropdownOption",
              "kind": "LinkedField",
              "name": "options",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isUsed",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "DropdownCustomField",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "fbf21f4e00356ad9c8b9666a368c0f4c";

export default node;
